var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            [
              _c(
                "b-button",
                {
                  attrs: { variant: "primary", size: "sm" },
                  on: { click: _vm.changeCampanha }
                },
                [_vm._v("Selecionar Campanha")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.campanha
            ? _c("b-col", { staticClass: "text-right" }, [
                _c("b", [
                  _vm._v(
                    "Campanha Selecionada: " +
                      _vm._s(_vm.getCamps(_vm.campanha))
                  )
                ])
              ])
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-3" },
        [
          _c(
            "b-col",
            { staticClass: "col-md-12" },
            [
              _vm.campanha != ""
                ? _c(
                    "b-card",
                    { attrs: { "no-body": "" } },
                    [
                      _c(
                        "b-tabs",
                        {
                          attrs: { card: "" },
                          model: {
                            value: _vm.tabIndex,
                            callback: function($$v) {
                              _vm.tabIndex = $$v
                            },
                            expression: "tabIndex"
                          }
                        },
                        [
                          _c(
                            "b-tab",
                            {
                              attrs: {
                                title: "Produtos",
                                "title-link-class": _vm.linkClass(0)
                              }
                            },
                            [
                              _c(
                                "b-row",
                                { attrs: { "align-v": "end" } },
                                [
                                  _c(
                                    "b-col",
                                    { attrs: { cols: "2" } },
                                    [
                                      _c("label", { attrs: { for: "" } }, [
                                        _vm._v("Produto")
                                      ]),
                                      _vm._v(" "),
                                      _c("b-form-input", {
                                        attrs: {
                                          size: "sm",
                                          type: "search",
                                          placeholder:
                                            "Código ou nome do produto",
                                          title: "Filtar Código"
                                        },
                                        on: {
                                          keyup: function($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "enter",
                                                13,
                                                $event.key,
                                                "Enter"
                                              )
                                            ) {
                                              return null
                                            }
                                            return _vm.loadProdutos()
                                          }
                                        },
                                        model: {
                                          value: _vm.filter.produto,
                                          callback: function($$v) {
                                            _vm.$set(_vm.filter, "produto", $$v)
                                          },
                                          expression: "filter.produto"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    [
                                      _c("label", { attrs: { for: "" } }, [
                                        _vm._v("Tipo")
                                      ]),
                                      _vm._v(" "),
                                      _c("b-form-select", {
                                        attrs: {
                                          size: "sm",
                                          options: [
                                            "",
                                            "CATALOGO",
                                            "ENCARTE",
                                            "REVENDA",
                                            "AUXILIAR"
                                          ]
                                        },
                                        model: {
                                          value: _vm.filter.tipo,
                                          callback: function($$v) {
                                            _vm.$set(_vm.filter, "tipo", $$v)
                                          },
                                          expression: "filter.tipo"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    [
                                      _c("label", { attrs: { for: "" } }, [
                                        _vm._v("App")
                                      ]),
                                      _vm._v(" "),
                                      _c("b-form-select", {
                                        attrs: {
                                          size: "sm",
                                          options: ["", "SIM", "NAO"]
                                        },
                                        model: {
                                          value: _vm.filter.ativo,
                                          callback: function($$v) {
                                            _vm.$set(_vm.filter, "ativo", $$v)
                                          },
                                          expression: "filter.ativo"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    [
                                      _c(
                                        "b-button",
                                        {
                                          attrs: {
                                            variant: "primary",
                                            size: "sm"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.loadProdutos()
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                                    Buscar\n                                "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "downloadexcel",
                                        {
                                          staticClass:
                                            "btn btn-success btn-sm mx-2",
                                          attrs: {
                                            fetch: _vm.fetchDataForExport,
                                            "before-generate": _vm.exportExcel,
                                            "before-finish": _vm.finishExcel,
                                            name: _vm.filename,
                                            worksheet: _vm.ExportProducts,
                                            title: "Lista de Produtos"
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "far fa-file-excel"
                                          }),
                                          _vm._v(
                                            " Exportar\n                                "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                { staticClass: "mt-3" },
                                [
                                  _c("b-table", {
                                    staticClass: "mt-2",
                                    attrs: {
                                      fields: _vm.colunas,
                                      hover: "",
                                      items: _vm.dataComputed,
                                      stacked: "md",
                                      "show-empty": "",
                                      small: "",
                                      "empty-text": "Nenhum produto encontrado!"
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "cell(id)",
                                          fn: function(row) {
                                            return [
                                              _c(
                                                "b-button",
                                                {
                                                  attrs: { variant: "primary" },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.show(row.value)
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "fas fa-eye"
                                                  })
                                                ]
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      1811817306
                                    )
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    { staticClass: "col-md-8" },
                                    [
                                      _c("b-pagination", {
                                        staticClass: "my-0",
                                        attrs: {
                                          "total-rows": _vm.totalRows,
                                          "per-page": _vm.perPage,
                                          align: "fill",
                                          size: "sm"
                                        },
                                        on: {
                                          input: function($event) {
                                            return _vm.loadProdutos()
                                          }
                                        },
                                        model: {
                                          value: _vm.currentPage,
                                          callback: function($$v) {
                                            _vm.currentPage = $$v
                                          },
                                          expression: "currentPage"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("b-col", { staticClass: "text-right" }, [
                                    _vm._v(
                                      "\n                                Total de Itens: "
                                    ),
                                    _c("b", [_vm._v(_vm._s(_vm.totalRows))])
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    { staticClass: "col-md-1" },
                                    [
                                      _c("b-form-select", {
                                        attrs: {
                                          size: "sm",
                                          options: _vm.optionsPerPage
                                        },
                                        on: {
                                          change: function($event) {
                                            return _vm.loadProdutos()
                                          }
                                        },
                                        model: {
                                          value: _vm.perPage,
                                          callback: function($$v) {
                                            _vm.perPage = $$v
                                          },
                                          expression: "perPage"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-tab",
                            {
                              attrs: {
                                title: "Categorias",
                                "title-link-class": _vm.linkClass(1)
                              }
                            },
                            [
                              _c(
                                "b-row",
                                [
                                  _c("b-table", {
                                    staticClass: "mt-2",
                                    attrs: {
                                      fields: _vm.colunasCategoria,
                                      hover: "",
                                      items: _vm.categorias,
                                      "current-page": _vm.currentPage,
                                      "per-page": _vm.perPage,
                                      "sort-by": _vm.sortBy,
                                      "sort-desc": _vm.sortDesc,
                                      "sort-direction": _vm.sortDirection,
                                      stacked: "md",
                                      "show-empty": "",
                                      "empty-text":
                                        "Nenhuma categoria encontrada!",
                                      small: ""
                                    },
                                    on: {
                                      "update:sortBy": function($event) {
                                        _vm.sortBy = $event
                                      },
                                      "update:sort-by": function($event) {
                                        _vm.sortBy = $event
                                      },
                                      "update:sortDesc": function($event) {
                                        _vm.sortDesc = $event
                                      },
                                      "update:sort-desc": function($event) {
                                        _vm.sortDesc = $event
                                      }
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "cell(imagem)",
                                          fn: function(row) {
                                            return [
                                              row.value
                                                ? _c("b-avatar", {
                                                    attrs: { src: row.value }
                                                  })
                                                : _vm._e()
                                            ]
                                          }
                                        },
                                        {
                                          key: "cell(subcategorias)",
                                          fn: function(row) {
                                            return [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    "font-size": "14px"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                        " +
                                                      _vm._s(row.value) +
                                                      "\n                                    "
                                                  )
                                                ]
                                              )
                                            ]
                                          }
                                        },
                                        {
                                          key: "cell(action)",
                                          fn: function(row) {
                                            return [
                                              _c(
                                                "b-button",
                                                {
                                                  attrs: { variant: "primary" },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.showCategoria(
                                                        row.item
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "fas fa-eye"
                                                  })
                                                ]
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      3569385259
                                    )
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            id: "modal-produtos",
            size: "lg",
            tabindex: "-1",
            title: _vm.produto.codigo + " - " + _vm.produto.nome
          },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function() {
                return [
                  _c(
                    "b-button",
                    {
                      staticClass: "float-right mr-2",
                      attrs: { variant: "primary", size: "sm" },
                      on: { click: _vm.saveProduto }
                    },
                    [_vm._v("Salvar")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      staticClass: "float-right mr-2",
                      attrs: { variant: "danger", size: "sm" },
                      on: {
                        click: function($event) {
                          _vm.modalProdutos = false
                        }
                      }
                    },
                    [_vm._v("Cancelar")]
                  )
                ]
              },
              proxy: true
            }
          ]),
          model: {
            value: _vm.modalProdutos,
            callback: function($$v) {
              _vm.modalProdutos = $$v
            },
            expression: "modalProdutos"
          }
        },
        [
          _c(
            "b-container",
            [
              _c(
                "b-row",
                [
                  _c("b-col", [
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", [
                        _vm._v("Deseja Bloquear produto no Aplicativo ?")
                      ]),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.produto.showapp,
                              expression: "produto.showapp"
                            }
                          ],
                          staticClass: "form-control",
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.produto,
                                "showapp",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            }
                          }
                        },
                        [
                          _c("option", { domProps: { value: true } }, [
                            _vm._v("Não")
                          ]),
                          _vm._v(" "),
                          _c("option", { domProps: { value: false } }, [
                            _vm._v("Sim")
                          ])
                        ]
                      )
                    ])
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c("b-col", { staticClass: "col-md-10" }, [
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c("label", [_vm._v("Imagens:")]),
                        _vm._v(" "),
                        _c("b-form-file", {
                          attrs: {
                            accept: ".jpg, .png, .jpeg",
                            multiple: "",
                            placeholder: "Nenhum Arquivo Selecionado",
                            "browse-text": "Selecionar Arquivo",
                            id: "imagem"
                          },
                          on: { change: _vm.setImagemProduto },
                          model: {
                            value: _vm.imagens,
                            callback: function($$v) {
                              _vm.imagens = $$v
                            },
                            expression: "imagens"
                          }
                        })
                      ],
                      1
                    )
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _vm._l(_vm.produto.imagens, function(imagem, index) {
                return _c(
                  "b-row",
                  { key: index, staticClass: "mt-3" },
                  [
                    _c("b-col", [
                      _c(
                        "a",
                        {
                          staticClass: "show-imagem",
                          attrs: { href: "#" },
                          on: {
                            click: function($event) {
                              return _vm.showImagem(imagem)
                            }
                          }
                        },
                        [
                          _c(
                            "b-img",
                            _vm._b(
                              {
                                attrs: {
                                  src: imagem.path,
                                  thumbnail: "",
                                  rounded: "",
                                  fluid: ""
                                }
                              },
                              "b-img",
                              { width: 80, height: 80 },
                              false
                            )
                          ),
                          _vm._v(" "),
                          _c("span", { staticClass: "ml-3" }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.nomeImagem(imagem.path)) +
                                "\n                        "
                            )
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "ml-2",
                          attrs: { href: "#", title: "Remover" },
                          on: {
                            click: function($event) {
                              return _vm.removeImagem(imagem)
                            }
                          }
                        },
                        [_c("i", { staticClass: "fas fa-times" })]
                      )
                    ])
                  ],
                  1
                )
              })
            ],
            2
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: { size: "xl", fluid: "", "hide-header": "", "ok-only": "" },
          model: {
            value: _vm.verProduto,
            callback: function($$v) {
              _vm.verProduto = $$v
            },
            expression: "verProduto"
          }
        },
        [
          _c(
            "b-container",
            { attrs: { fluid: "" } },
            [
              _c(
                "b-row",
                { staticClass: "mb-1 text-center" },
                [
                  _c("b-img", {
                    attrs: { src: _vm.pathImagem, "fluid-grow": "" }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            id: "modal-campanhas",
            tabindex: "-1",
            title: "Selecione uma Campanha",
            "ok-only": ""
          },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function() {
                return [
                  _c(
                    "b-button",
                    {
                      staticClass: "float-right",
                      attrs: { variant: "primary", size: "sm" },
                      on: {
                        click: function($event) {
                          _vm.modalCampanhas = false
                        }
                      }
                    },
                    [_vm._v("Fechar")]
                  )
                ]
              },
              proxy: true
            }
          ]),
          model: {
            value: _vm.modalCampanhas,
            callback: function($$v) {
              _vm.modalCampanhas = $$v
            },
            expression: "modalCampanhas"
          }
        },
        [
          _c(
            "b-container",
            [
              _c("b-form-select", {
                attrs: { options: _vm.camps },
                on: {
                  change: function($event) {
                    return _vm.setCampanha(_vm.campanha)
                  }
                },
                model: {
                  value: _vm.campanha,
                  callback: function($$v) {
                    _vm.campanha = $$v
                  },
                  expression: "campanha"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            size: "lg",
            id: "modal-categoria",
            title: _vm.categoriaSelecionada.categoria
          },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function() {
                return [
                  _c(
                    "b-button",
                    {
                      attrs: { size: "sm", variant: "success" },
                      on: {
                        click: function($event) {
                          return _vm.saveCategoria()
                        }
                      }
                    },
                    [
                      _c("i", { staticClass: "fas fa-save" }),
                      _vm._v("\n                Salvar")
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: { size: "sm", variant: "danger" },
                      on: {
                        click: function($event) {
                          _vm.modalCategoria = false
                        }
                      }
                    },
                    [_vm._v("Cancelar")]
                  )
                ]
              },
              proxy: true
            }
          ]),
          model: {
            value: _vm.modalCategoria,
            callback: function($$v) {
              _vm.modalCategoria = $$v
            },
            expression: "modalCategoria"
          }
        },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { staticClass: "text-left col-md-2" },
                [
                  _c("label", { attrs: { for: "" } }, [_vm._v("Prioridade")]),
                  _vm._v(" "),
                  _c("b-select", {
                    attrs: { options: _vm.optionsOrdem },
                    model: {
                      value: _vm.categoriaSelecionada.ordem,
                      callback: function($$v) {
                        _vm.$set(_vm.categoriaSelecionada, "ordem", $$v)
                      },
                      expression: "categoriaSelecionada.ordem"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.categoriaSelecionada.imagem
            ? _c(
                "b-row",
                { staticClass: "mb-3 mt-3", attrs: { "align-v": "center" } },
                [
                  _c(
                    "b-col",
                    { staticClass: "text-right" },
                    [
                      _c("b-avatar", {
                        attrs: {
                          src: _vm.categoriaSelecionada.imagem,
                          size: "8rem"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "text-left" },
                    [
                      _c(
                        "b-button",
                        {
                          attrs: { size: "sm", variant: "danger" },
                          on: {
                            click: function($event) {
                              return _vm.removeImagemCategoria()
                            }
                          }
                        },
                        [_vm._v("Remover Imagem")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "mt-3" },
            [
              _c(
                "b-col",
                { staticClass: "col-md-12" },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: _vm.categoriaSelecionada.imagem
                          ? "Alterar Ícone"
                          : "Adicionar Icone",
                        "label-cols-sm": "2"
                      }
                    },
                    [
                      _c("b-form-file", {
                        attrs: {
                          accept: ".jpg, .png, .jpeg",
                          placeholder: "Nenhum Arquivo Selecionado",
                          "browse-text": "Selecionar Arquivo",
                          id: "imagem"
                        },
                        model: {
                          value: _vm.categoriaSelecionada.novaImagem,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.categoriaSelecionada,
                              "novaImagem",
                              $$v
                            )
                          },
                          expression: "categoriaSelecionada.novaImagem"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-01d5c066", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01d5c066","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/produtos/AdmProdutos.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-01d5c066","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/produtos/AdmProdutos.vue
// module chunks = 2